import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { UrlHelper } from "../../../helper";
import { DomainId, LOCALE_CONFIG, Locale, LocaleConfig, getEnvConfig } from "../../config";
import { DatoCmsService } from "../dato-cms";

@Injectable()
export class AppvizerUrlService {

  // enables console logging
  developmentMode = false;

  domainId: DomainId;
  domainUrl: string; // i.e. https://appvizer.co.uk/
  softwareCenterUrl: string;
  magazinePath: string; // i.e magazine
  newsPath: string; // i.e magazine/news

  readonly initialized$ = new BehaviorSubject<boolean>(false);

  /*
   * Get the url of the appvizer application's url based on the article's current locale
   */
  constructor(
    private readonly cms: DatoCmsService,
    private readonly route: ActivatedRoute
  ) {
    let datoPlugin: any;

    this.cms.getPluginInitializer().pipe(
      tap(plugin => {
        datoPlugin = plugin;
        const pluginParameters = plugin.parameters.global;
        this.developmentMode = pluginParameters.developmentMode;

        const currentLocale: Locale = datoPlugin.locale.replace("-", "_");
        const envConfig = getEnvConfig(this.route.snapshot.queryParamMap.get('env'));

        this.domainUrl = UrlHelper.removeTrailingSlashes(envConfig.localeConfig[currentLocale].url);
        this.softwareCenterUrl = UrlHelper.removeTrailingSlashes(envConfig.softwareCenterUrl);

        const localeConfig = this.getLocaleConfigFromPlugin(plugin);
        this.domainId = localeConfig.domainId;
        this.magazinePath = localeConfig.magazinePath;
        this.newsPath = localeConfig.newsPath;
      }),
    )
      .subscribe(
        () => this.initialized$.next(true),
        err => this.logErrorIfDevelopmentMode(err));
  }

  public getLocaleConfig(): Observable<LocaleConfig> {
    return this.cms.getPluginInitializer()
      .pipe(
        map(plugin => this.getLocaleConfigFromPlugin(plugin))
      );
  }

  private getLocaleConfigFromPlugin(plugin: any): LocaleConfig {
    return LOCALE_CONFIG[plugin.locale.replace("-", "_")];
  }

  logErrorIfDevelopmentMode(message: string): void {
    if (this.developmentMode) {
      console.error(message);
    }
  }

}
